import { string, object, mixed } from 'yup';


export const LITIGATION_CREATION_FIELDS = {

  particular: {
    type: "text",
    name: "particular",
    label: "Particular",
  },
  period: {
    type: "text",
    name: "period",
    label: "Period",
  },
  current_status: {
    type: "text",
    name: "current_status",
    label: "Current Status",
  },
  final_status: {
    type: "text",
    name: "final_status",
    label: "Final Status",
  },
  notices_and_orders: {
    type: "file",
    name: "notices_and_orders",
    label: "Notices and Orders",
  },
};


export const LITIGATION_CREATION_SCHEMA = object().shape({
  lit_id: string().when([], {
    is: (val) => !!val,
    then: string().required("Litigation ID is required for updates"),
  }),
  particular: string().required("Particular is required"),
  period: string().required("Period is required"),
  current_status: string().required("Current Status is required"),
  final_status: string().required("Final Status is required"),
  notices_and_orders: mixed()
    .test("fileSize", "File size is too large", (value) => {
      if (!value) return true; // 👈 allow empty
      return value.size <= 5 * 1024 * 1024;
    })
    .test("fileType", "Unsupported file format", (value) => {
      if (!value) return true; // 👈 allow empty
      return ["application/pdf", "image/jpeg", "image/png"].includes(value.type);
    }),
});


